<div class="flip-card">
  <div class="flip-card-inner" [ngClass]="flipped ? 'flip-card-true' : null">
    <mat-card class="widget-card flip-card-front">
      <mat-card-title class="container-fluid">
        <div class="row d-flex align-items-center" style="margin: -5px">
          <div class="title col-auto">Agitação Marítima</div>
          <div class="flex-fill"></div>
          <button mat-raised-button class="mr-2" (click)="openMap()">
            <i class="fas fa-map fa-lg"></i>
          </button>
          <button mat-raised-button (click)="flipped = true">
            <i class="fas fa-info fa-lg"></i>
          </button>
        </div>
      </mat-card-title>
      <hr />
      <mat-card-content>
        <div
          class="container-fluid justify-content-center mb-0 mr-4 ml-0"
          style="min-height: 70px"
          [ngClass]="isLastValuesModeled ? '' : 'modeled-box'"
        >
          <div
            *ngIf="!isLastValuesModeled"
            class="row d-flex justify-content-center align-items-center mb-2"
          >
            <b class="small-info-bold">Valores medidos </b>
            <span class="small-info"
              >a {{ lastValuesDate | date : "dd/MM/yyyy 'às' HH:mm" : "en" }}
            </span>
              <i
                class="fas fa-exclamation-triangle ml-2"
                *ngIf="!isDataUnderTolerance()"
                matTooltip="A comunicação com a fonte de dados encontra-se temporariamente indisponível"
                style="color: #FFD43B; cursor: pointer"
              ></i>
              <i
                (click)="flipped = true"
                *ngIf="isDataUnderTolerance()"
                class="fas fa-info-circle ml-2 fa-lg"
                style="color: white; cursor: pointer"
              ></i>
          </div>
          <div
            *ngIf="isLastValuesModeled"
            class="row d-flex justify-content-center align-items-center small-info mb-2"
          >
            <b class="small-info-bold">Valores previstos </b>
            <span class="small-info"
              >para {{ lastValuesDate | date: "dd/MM/yyyy 'às' HH:mm":"en" }}
            </span>
            <i
              (click)="flipped = true"
              class="fas fa-info-circle ml-2 fa-lg"
              style="color: white; cursor: pointer"
            ></i>
          </div>
          <div class="row d-flex justify-content-center">
            <div class="col-auto" *ngIf="checkExists(3.1)">
              <div class="parameter-title">
                Direção média:
                <div class="value d-flex justify-content-center">
                  <i
                    class="fas fa-location-circle theme-fa-accent"
                    [style.transform]="'rotate(' + getRotation(3.1) + ')'"
                  ></i>
                  <span>
                    {{ mappedData.get(3.1)[0] | getSerieValue }}
                    {{ mappedData.get(3.1)[0] | directionCompassRose }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-auto" *ngIf="checkExists(3.4)">
              <div class="parameter-title">
                Altura significativa:
                <div class="value d-flex justify-content-center">
                  <i class="fad fa-water theme-fa-accent"></i
                  ><span> {{ mappedData.get(3.4)[0] | getSerieValue }}</span>
                </div>
              </div>
            </div>
            <div class="col-auto" *ngIf="checkExists(3.6)">
              <div class="parameter-title">
                Altura máxima:
                <div class="value d-flex justify-content-center">
                  <i class="fad fa-water-rise theme-fa-accent"></i
                  ><span> {{ mappedData.get(3.6)[0] | getSerieValue }}</span>
                </div>
              </div>
            </div>
            <div class="col-auto" *ngIf="checkExists(3.2)">
              <div class="parameter-title">
                Período médio:
                <div class="value d-flex justify-content-center">
                  <i class="fas fa-clock theme-fa-accent"></i
                  ><span> {{ mappedData.get(3.2)[0] | getSerieValue }}</span>
                </div>
              </div>
            </div>
            <div class="col-auto" *ngIf="checkExists(3.5)">
              <div class="parameter-title">
                Período de pico:
                <div class="value">
                  <i class="fas fa-clock theme-fa-accent"></i
                  ><span> {{ mappedData.get(3.5)[0] | getSerieValue }}</span>
                </div>
              </div>
            </div>
            <div class="col-auto" *ngIf="checkExists(3.7)">
              <div class="parameter-title">
                Temperatura da água:
                <div class="value">
                  <i class="fad fa-temperature-low theme-fa-accent"></i
                  ><span>{{ mappedData.get(3.7)[0] | getSerieValue }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="sub-title mt-2">Previsão</p>
        <hr />
        <div
          style="
            height: 450px;
            background-color: rgba(0, 0, 0, 0.5);
            margin: -10px;"
          >
          <div id="wavesChart" style="width: 100%; height: 100%"></div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="widget-card flip-card-back"
      ><mat-card-title class="container-fluid">
        <div class="row d-flex align-items-center" style="margin: -5px">
          <div class="title-negative col-auto">Agitação Marítima</div>
          <div class="flex-fill"></div>
          <button mat-raised-button class="mr-2" (click)="openMap()">
            <i class="fas fa-map fa-lg"></i>
          </button>
          <button mat-raised-button (click)="flipped = false">
            <i class="fas fa-info fa-lg"></i>
          </button>
        </div>
      </mat-card-title>
      <hr />
      <mat-card-content><app-waves-info></app-waves-info> </mat-card-content
    ></mat-card>
  </div>
</div>
